"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBeginCheckoutFragment = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _client = require("@apollo/client");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  fragment useBeginCheckoutFragment on Store {\n    id\n    adTracks {\n      googleAnalyticsId\n      googleAdwordsConfig\n      googleAdwordsBeginCheckout\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// definition
var useBeginCheckoutFragment = (0, _client.gql)(_templateObject());
exports.useBeginCheckoutFragment = useBeginCheckoutFragment;